/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable sort-keys */
import {
    createTheme
} from '@mui/material/styles';

import {
    colors
} from './colors';

const SIZE_MUI_SM = 600 as const;
const SIZE_MUI_MD = 900 as const;
const SIZE_MUI_LG = 1200 as const;
const SIZE_MUI_XL = 1536 as const;

const SIZE_MOBILE_SMALL = 360 as const;
const SIZE_MOBILE_MEDIUM = 392 as const;
const SIZE_MOBILE_LARGE = 432 as const;
const SIZE_TABLET_SMALL = 680 as const;
const SIZE_TABLET_MEDIUM = 800 as const;
const SIZE_TABLET_LARGE = 912 as const;
const SIZE_DESKTOP_SMALL = 1060 as const;
const SIZE_DESKTOP_MEDIUM = 1368 as const;
const SIZE_DESKTOP_LARGE = 1600 as const;

const muiTheme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            mobileSmall: SIZE_MOBILE_SMALL,
            mobileMedium: SIZE_MOBILE_MEDIUM,
            mobileLarge: SIZE_MOBILE_LARGE,
            sm: SIZE_MUI_SM,
            tabletSmall: SIZE_TABLET_SMALL,
            tabletMedium: SIZE_TABLET_MEDIUM,
            md: SIZE_MUI_MD,
            tabletLarge: SIZE_TABLET_LARGE,
            desktopSmall: SIZE_DESKTOP_SMALL,
            lg: SIZE_MUI_LG,
            desktopMedium: SIZE_DESKTOP_MEDIUM,
            xl: SIZE_MUI_XL,
            desktopLarge: SIZE_DESKTOP_LARGE
        }
    },
    // expose *all* SCSS tokens as theme.colors
    colors,
    typography: {
        fontFamily: "'Poppins', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif"
    }
});

export default muiTheme;
